import React from 'react';
import './BrandLogo.css';
import BrandText from './BrandText';

/**
 * BrandLogo - Renders the brand vector mark, with optional knight emblem
 * @param {string} className - Additional CSS classes
 * @param {string} size - Size variant: 'xs' | 'sm' | 'default' | 'md' | 'lg' | 'xl'
 * @param {boolean} collapsed - Whether the logo is displayed in a collapsed sidebar (renders knight emblem)
 * @param {boolean} showIcon - Whether to display the knight emblem before the text
 * @param {boolean} iconOnly - Whether to only show the emblem
 * @param {string} text - Brand text (defaults to 'KnightSteps')
 */
const BrandLogo = ({
  className = '',
  size = 'default',
  collapsed = false,
  showIcon = true,
  iconOnly = false,
  text = 'KnightSteps',
}) => {
  if (collapsed || iconOnly) {
    return (
      <span className={`ks-brand-logo ${size ? `ks-brand-logo--${size}` : ''} is-collapsed ${className}`.trim()} aria-label={text}>
        <img
          src="/images/logo/knight-logo.webp"
          alt={text}
          className="ks-brand-emblem-collapsed"
          onError={(e) => {
            if (!e.target.dataset.fallback) {
              e.target.dataset.fallback = 'true';
              e.target.src = '/images/logo/knight-logo.png';
            }
          }}
        />
      </span>
    );
  }

  return (
    <span
      className={`ks-brand-logo ${size ? `ks-brand-logo--${size}` : ''} ${showIcon ? 'has-icon' : ''} ${className}`.trim()}
      aria-label={text}
    >
      {showIcon && (
        <img
          src="/images/logo/knight-logo.webp"
          alt=""
          className="ks-brand-emblem"
          onError={(e) => {
            if (!e.target.dataset.fallback) {
              e.target.dataset.fallback = 'true';
              e.target.src = '/images/logo/knight-logo.png';
            }
          }}
        />
      )}
      {text === 'KnightSteps' ? (
        <BrandText className="ks-brand-full-svg" />
      ) : (
        <span className="ks-brand-full">{text}</span>
      )}
    </span>
  );
};

export default BrandLogo;
